import { jsx } from "react/jsx-runtime";
import { useState, useRef, useCallback } from "react";
import { useGoogleAutocomplete } from "../../hooks/useGoogleAutocomplete.js";
import { useGeocoder } from "../../hooks/useGeocoder.js";
import { Combobox } from "../../../components/SelectControl/Combobox/Combobox.js";
import { getAddressInfo } from "../../getAddressInfo.js";
import { highlightMatches } from "../../../utils/highlightMatches.js";
import { useInitialization } from "./useInitialization.js";
const autocompletePredictionMapper = (data) => ({
  value: data.place_id,
  labelSelection: highlightMatches(data.description, data.matched_substrings),
  label: data.description
}), GoogleAutocomplete = ({
  placeholder,
  searchBy,
  value,
  onChange,
  onInputChange,
  ...restProps
}) => {
  const { search } = useGoogleAutocomplete(), getAddress = useGeocoder(), [data, setData] = useState([]), [inputValue, setInputValue] = useState(""), [draftInputValue, setDraftInputValue] = useState(""), refs = useRef({ onChange });
  refs.current = {
    onChange
  };
  const handleSearchByPressingEnterKey = useCallback(
    async (e) => {
      var _a, _b, _c, _d;
      if (e.key === "Enter")
        try {
          const address = await (getAddress == null ? void 0 : getAddress({ address: draftInputValue }));
          if (setData([]), address && address.address_components.length > 1) {
            const addressInfo = getAddressInfo(address);
            (_b = (_a = refs.current).onChange) == null || _b.call(_a, addressInfo), setInputValue(addressInfo.formattedAddress);
          } else
            (_d = (_c = refs.current).onChange) == null || _d.call(_c, null), setInputValue("");
        } catch {
        }
    },
    [draftInputValue, getAddress]
  ), handleInputChange = useCallback(
    async (str) => {
      if (setDraftInputValue(str), onInputChange == null || onInputChange(str), !str.length) {
        setData([]);
        return;
      }
      try {
        const result = await search(str);
        setData(result ?? []);
      } catch {
        console.error("[GoogleAutocomplete] Search gone wrong");
      }
    },
    [onInputChange, search]
  ), handleChange = useCallback(
    async (_, placeId) => {
      var _a, _b, _c, _d;
      if (!placeId) {
        (_b = (_a = refs.current).onChange) == null || _b.call(_a, null), setInputValue(""), setData([]);
        return;
      }
      const result = await (getAddress == null ? void 0 : getAddress({ placeId }));
      if (result) {
        const addr = getAddressInfo(result);
        (_d = (_c = refs.current).onChange) == null || _d.call(_c, addr), setInputValue(addr.formattedAddress), setData([]);
      }
    },
    [getAddress]
  );
  return useInitialization({
    getAddress,
    onChange: (address) => {
      var _a, _b;
      const addressInfo = getAddressInfo(address);
      (_b = (_a = refs.current).onChange) == null || _b.call(_a, addressInfo), setInputValue(addressInfo.formattedAddress);
    },
    searchBy
  }), /* @__PURE__ */ jsx(
    Combobox,
    {
      onKeyUp: handleSearchByPressingEnterKey,
      inputValue: value ?? inputValue,
      getItemData: autocompletePredictionMapper,
      data,
      placeholder,
      onInputChange: handleInputChange,
      onChange: handleChange,
      ...restProps
    }
  );
};
export {
  GoogleAutocomplete
};
//# sourceMappingURL=GoogleAutocomplete.js.map
